import {
  GET_SUCCESS_CONFIGURATION_TYPE_REQUEST,
  GET_SUCCESS_CONFIGURATION_TYPE_SUCCESS,
  GET_SUCCESS_CONFIGURATION_TYPE_FAILED,
  UPDATE_SUCCESS_CONFIGURATION_TYPE_REQUEST,
  UPDATE_SUCCESS_CONFIGURATION_TYPE_SUCCESS,
  UPDATE_SUCCESS_CONFIGURATION_TYPE_FAILED,
  CANCEL_SUCCESSED,
} from './actionTypes';

const initialState = {
  typeInfo: null,
  successed: false,
};

const list = (state = initialState, {
  type, typeInfo, error,
}) => {
  switch (type) {
    case GET_SUCCESS_CONFIGURATION_TYPE_REQUEST:
      return {
        ...state,
        loading: true,
        typeInfo: null,
        successed: false,
      };
    case GET_SUCCESS_CONFIGURATION_TYPE_SUCCESS:
      return {
        ...state, loading: false, typeInfo,
      };
    case GET_SUCCESS_CONFIGURATION_TYPE_FAILED:
      return {
        ...state, loading: false, error,
      };
    case UPDATE_SUCCESS_CONFIGURATION_TYPE_REQUEST:
      return {
        ...state, loading: true,
      };
    case UPDATE_SUCCESS_CONFIGURATION_TYPE_SUCCESS:
      return {
        ...state, loading: false, successed: true,
      };
    case UPDATE_SUCCESS_CONFIGURATION_TYPE_FAILED:
      return {
        ...state, loading: false, error,
      };
    case CANCEL_SUCCESSED:
      return {
        ...state, successed: false,
      };
    default:
      return state;
  }
};

export default list;
